export enum SignatureType {
  cryptoSignature = 'cryptoSignature',
  eSignature = 'eSignature',
  externalSignature = 'externalSignature',
}
